<script setup lang="ts">
import Autoplay from 'embla-carousel-autoplay'
import { Card, CardContent } from '@/components/ui/card'
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from '@/components/ui/carousel'

const advantages = [
  {
    title: 'Высокий процент одобрения',
    description: 'Каждая заявка рассматривается индивидуально. Главное условие – наличие постоянного дохода',
  },
  {
    title: 'Прозрачность условий',
    description: 'С каждым клиентом мы заключаем понятный и прозрачный договор',
  },
  {
    title: 'Персональный менеджер',
    description: 'Ваш персональный менеджер всегда на связи',
  },
  {
    title: 'Удобство оплаты',
    description: 'Мы предлагаем небольшие еженедельные платежи',
  },
  {
    title: 'Качество обслуживания',
    description: 'Заполнение заявки всего за 10 минут',
  },
]
</script>

<template>
  <section class="py-16">
    <div class="container mx-auto px-4 max-w-screen-xl">
      <div class="text-center mb-6">
        <h2 class="text-3xl font-bold text-title mb-2">
          Наши преимущества
        </h2>
      </div>

      <Carousel
        class="w-full mx-auto relative"
        :opts="{ align: 'start', loop: true }"
        :plugins="[Autoplay({
          delay: 5000,
        })]"
      >
        <ClientOnly>
          <CarouselPrevious
            class="hidden xl:flex absolute -left-12 top-1/2 -translate-y-1/2 bg-white border-gray-300 text-gray-700 shadow-sm"
          />
          <CarouselNext
            class="hidden xl:flex absolute -right-12 top-1/2 -translate-y-1/2 bg-white border-gray-300 text-gray-700 shadow-sm"
          />
        </ClientOnly>

        <CarouselContent class="-ml-1 py-2">
          <CarouselItem
            v-for="(item, index) in advantages"
            :key="index"
            class="pl-2 md:basis-1/2 lg:basis-1/3 hover:cursor-grab"
          >
            <div class="p-1">
              <Card class="h-64 bg-white rounded-lg shadow-md border-none md:hover:scale-105 transition-transform duration-300">
                <CardContent class="flex flex-col items-center p-6 h-full">
                  <div class="mb-4 text-blue-600">
                    <NuxtImg class="size-[72px]" loading="lazy" src="/img/icon_advantages.svg" alt="Преимущество" />
                  </div>
                  <h3 class="text-xl font-semibold mb-2 text-center">
                    {{ item.title }}
                  </h3>
                  <p class="text-gray-600 text-center">
                    {{ item.description }}
                  </p>
                </CardContent>
              </Card>
            </div>
          </CarouselItem>
        </CarouselContent>
        <ClientOnly>
          <div class="xl:hidden mt-6 flex justify-center gap-4">
            <CarouselPrevious class="static translate-y-0 bg-white border-gray-300 text-gray-700 " />
            <CarouselNext class="static translate-y-0 bg-white border-gray-300 text-gray-700 " />
          </div>
        </ClientOnly>
      </Carousel>
    </div>
  </section>
</template>

<style scoped>
.card-shadow {
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}

:deep(.carousel__prev),
:deep(.carousel__next) {
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
</style>
